import apiClient from '../authentication/utils/core/axios';

/**
 * RoadmapAPI — admin-only CRUD for the platform roadmap/todo tracker, mirroring
 * Technical_Docs/08_MASTER_TODO.md so it becomes a live, editable, in-app view
 * of what's open across the backend/frontend rather than a static doc only.
 */
const RoadmapAPI = {
  fetchItems: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.status) query.append('status', params.status);
    if (params.severity) query.append('severity', params.severity);
    // 30s, not the client default (15s) -- see meetingNotesApi.js's
    // fetchNotes for the full reasoning (same single-worker admin-dashboard
    // load pattern affects this call too).
    const res = await apiClient.get(`/admin/roadmap/?${query.toString()}`, { timeout: 30000 });
    return res.data;
  },

  createItem: async (itemData) => {
    const res = await apiClient.post('/admin/roadmap/', itemData);
    return res.data;
  },

  updateItem: async (itemId, updates) => {
    const res = await apiClient.patch(`/admin/roadmap/${itemId}`, updates);
    return res.data;
  },

  deleteItem: async (itemId) => {
    await apiClient.delete(`/admin/roadmap/${itemId}`);
    return itemId;
  },
};

export default RoadmapAPI;
